import { commandOnSurface, formatShortcut, isAvailableElement, shortcuts } from "./commands.js"

// Keep generated hints outside React-owned children and preserve existing titles.
export class DomShortcutHints {
  constructor(root) {
    this.root = root
    this.controls = new Map()
  }

  render(commands) {
    const current = new Set()
    for (const command of commands) {
      const element = typeof command.element === "function" ? command.element() : command.element
      if (!element?.matches("button, a, input")) continue
      if (element.dataset.shortcutHintManaged === "external") {
        this.controls.get(element)?.hint?.remove()
        this.controls.delete(element)
        continue
      }
      current.add(element)
      let state = this.controls.get(element)
      if (!state) {
        state = { title: element.getAttribute("title") || "", hint: null }
        this.controls.set(element, state)
      }
      const keys = commandOnSurface(command.id, this.root.dataset.keyboardShortcutsSurface) && isAvailableElement(element)
        ? shortcuts.bindingFor(command.id, command.keys) : undefined
      const aria = keys?.replace("mod", shortcuts.mac ? "Meta" : "Control")
      if (aria) element.setAttribute("aria-keyshortcuts", aria)
      else element.removeAttribute("aria-keyshortcuts")
      const title = [state.title, formatShortcut(keys)].filter(Boolean).join(" · ")
      if (title) element.setAttribute("title", title)
      else element.removeAttribute("title")

      if (!keys || element.dataset.shortcutHintManaged === "true" || element.tagName === "INPUT" ||
        element.closest('#sidebar_nav_container, .menu, [role="menu"]')) {
        (state.hint || element.querySelector(":scope > kbd[data-shortcut-hint-for]"))?.remove()
        state.hint = null
        continue
      }
      if (!state.hint?.isConnected) {
        state.hint = element.querySelector(":scope > kbd[data-shortcut-hint-for]") || this.root.ownerDocument.createElement("kbd")
        state.hint.className = "keyboard-shortcut-hint keyboard-shortcut-badge"
        state.hint.setAttribute("aria-hidden", "true")
        state.hint.dataset.shortcutHintFor = command.id
        element.append(state.hint)
      }
      state.hint.textContent = formatShortcut(keys)
    }
    for (const [element, state] of this.controls) {
      if (current.has(element)) continue
      this.restore(element, state)
      this.controls.delete(element)
    }
  }

  restore(element, state) {
    state.hint?.remove()
    element.removeAttribute("aria-keyshortcuts")
    if (state.title) element.setAttribute("title", state.title)
    else element.removeAttribute("title")
  }

  disconnect() {
    for (const [element, state] of this.controls) this.restore(element, state)
    this.controls.clear()
  }
}
